"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var React = require("react");
var pop_up_1 = require("../../../common/modal/pop-up");
var button_component_1 = require("../../../common/buttons/button_component");
var api_1 = require("../role_management/api");
var react_hot_toast_1 = require("react-hot-toast");
var array_helpers_1 = require("../../../utils/array_helpers");
var menu_constants_1 = require("../../../menuList/menu_constants");
var DeleteUserButton = function (_a) {
    var _b = _a.userId, userId = _b === void 0 ? '' : _b, _c = _a.userName, userName = _c === void 0 ? '' : _c, _d = _a.is_active, is_active = _d === void 0 ? 0 : _d;
    var userFeatures = (0, array_helpers_1.getAccessibleFeatures)(menu_constants_1.FEATURE_CONSTANTS.userManagement);
    var _e = React.useState(false), showPopup = _e[0], setShowPopup = _e[1];
    var _f = React.useState(is_active ? true : false), checkedStatus = _f[0], setCheckedStatus = _f[1];
    var _g = React.useState(false), showStatusPopup = _g[0], setShowStatusPopup = _g[1];
    var _h = React.useState(null), pendingStatus = _h[0], setPendingStatus = _h[1];
    var handleDelete = function () {
        setShowPopup(true);
    };
    var handleConfirm = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, err_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4, (0, api_1.userStatusUpdate)({ user_id: userId })];
                case 1:
                    res = _c.sent();
                    if ((res === null || res === void 0 ? void 0 : res.status) === 200) {
                        react_hot_toast_1.default.success("User deleted successfully");
                        setShowPopup(false);
                        window.dispatchEvent(new Event('user-deleted'));
                    }
                    else {
                        react_hot_toast_1.default.error(((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.message) || 'Failed to delete user');
                    }
                    return [3, 3];
                case 2:
                    err_1 = _c.sent();
                    react_hot_toast_1.default.error(((_b = err_1 === null || err_1 === void 0 ? void 0 : err_1.data) === null || _b === void 0 ? void 0 : _b.message) || (err_1 === null || err_1 === void 0 ? void 0 : err_1.message) || 'Failed to delete user');
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    var handleCancel = function () {
        setShowPopup(false);
    };
    var handleSwitchChange = function (event) {
        event.preventDefault();
        var newStatus = event.target.checked;
        setPendingStatus(newStatus);
        setShowStatusPopup(true);
    };
    var handleStatusConfirm = function () { return __awaiter(void 0, void 0, void 0, function () {
        var statusValue, res, actionText, err_2;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (pendingStatus === null) {
                        return [2];
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    statusValue = pendingStatus ? 1 : 0;
                    return [4, (0, api_1.userStatusUpdate)({ user_id: userId, status: statusValue })];
                case 2:
                    res = _c.sent();
                    if ((res === null || res === void 0 ? void 0 : res.status) === 200) {
                        actionText = pendingStatus ? 'activate' : 'deactivate';
                        react_hot_toast_1.default.success("User ".concat(actionText, "d successfully"));
                        setCheckedStatus(pendingStatus);
                        setShowStatusPopup(false);
                        setPendingStatus(null);
                        window.dispatchEvent(new Event('user-status-updated'));
                    }
                    else {
                        react_hot_toast_1.default.error(((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.message) || 'Failed to update user status');
                    }
                    return [3, 4];
                case 3:
                    err_2 = _c.sent();
                    react_hot_toast_1.default.error(((_b = err_2 === null || err_2 === void 0 ? void 0 : err_2.data) === null || _b === void 0 ? void 0 : _b.message) || (err_2 === null || err_2 === void 0 ? void 0 : err_2.message) || 'Failed to update user status');
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    var userStatusCancel = function () {
        setShowStatusPopup(false);
        setPendingStatus(null);
    };
    var isDisabled = !userFeatures[menu_constants_1.FEATURE_CONSTANTS.editUser];
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { display: 'flex', alignItems: 'center', gap: '12px' } },
            React.createElement(material_1.IconButton, { className: isDisabled ? "icon-btn icon-disabled" : "icon-btn", onClick: handleDelete, disabled: isDisabled },
                React.createElement("span", { className: "icon-delete_forever" })),
            React.createElement(material_1.Switch, { checked: checkedStatus, onChange: handleSwitchChange, disabled: isDisabled || showStatusPopup })),
        React.createElement(pop_up_1.default, { open: showPopup },
            React.createElement("div", { className: "modal-header" },
                React.createElement("h2", { className: "heading" }, "Delete User"),
                React.createElement("h2", { className: "sub-heading" },
                    "Are you sure you want to delete ",
                    userName ? "\"".concat(userName, "\"") : 'this user',
                    "? This action cannot be undone.")),
            React.createElement("div", { className: "modal-footer sticky-modal-footer" },
                React.createElement(button_component_1.default, { buttonName: "Cancel", color: "yellow-outline", onClickHandler: handleCancel }),
                React.createElement(button_component_1.default, { buttonName: 'Delete', color: "yellow", onClickHandler: handleConfirm, isError: false }))),
        React.createElement(pop_up_1.default, { open: showStatusPopup },
            React.createElement("div", { className: "modal-header" },
                React.createElement("h2", { className: "heading" }, pendingStatus ? 'Activate User' : 'Deactivate User'),
                React.createElement("h2", { className: "sub-heading" },
                    "Are you sure you want to ",
                    pendingStatus ? 'activate' : 'deactivate',
                    " ",
                    userName ? "\"".concat(userName, "\"") : 'this user',
                    "?")),
            React.createElement("div", { className: "modal-footer sticky-modal-footer" },
                React.createElement(button_component_1.default, { buttonName: "Cancel", color: "yellow-outline", onClickHandler: userStatusCancel }),
                React.createElement(button_component_1.default, { buttonName: pendingStatus ? 'Activate' : 'Deactivate', color: "yellow", onClickHandler: handleStatusConfirm, isError: false })))));
};
exports.default = DeleteUserButton;
